import {isNil, last} from 'ramda';
import {isNotNil} from 'ramda-adjunct';

import {DrillDownStatistics} from '@dms/api/core';

import {getSafely, Nullish} from 'shared/web';

import {LevelConfiguration} from '../types';

export function getFirstColumnText(
  data: DrillDownStatistics,
  levelConfiguration: LevelConfiguration | Nullish,
  translations: Record<string, string>
): string | null {
  const value = last(data.levels)?.value ?? '';

  if (isNotNil(levelConfiguration?.getValueLabel)) {
    return levelConfiguration.getValueLabel(value, translations);
  }

  const text = getSafely(translations, value);

  if (isNil(text)) {
    return null;
  }

  return isNotNil(levelConfiguration) && levelConfiguration.formatter
    ? levelConfiguration.formatter(text)
    : text;
}
